import { AppService } from './../core/app.service';
import { Injectable } from "@angular/core";
import { AbstractService } from "../core/AbstractService";
import { RegroupementActiviteReq } from "../data/http/requests/regroupementactivities.req";
import { RegroupementActiviteRes } from "../data/http/responses/regroupementactivities.res";
import { HttpClient } from "@angular/common/http";
import { env } from "../../env/env";

@Injectable({
    providedIn: 'root'
})
export class RegroupementActiviteService extends AbstractService<RegroupementActiviteReq, RegroupementActiviteRes> {
    constructor(http: HttpClient, AppService: AppService) {
        super(`${env.apiUrl}activite`, http, AppService); 
    }
}